export class Controller {

    $onInit() {
        this.roles = this.resolve.roles;
        this.role = {roleValue: ''};
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/login-role-select/login-role-select.controller.js